import React from 'react'
import './footer.scss'

const Footer = () => {
  return (
    <div>Footer</div>
  )
}

export default Footer